import React, { Component } from 'react';
import { useField, Formik, Form, Field, ErrorMessage, useFormikContext } from 'formik';
import moment from 'moment-timezone';
import TimeStampField from "./TimestampField";
import { observer } from "mobx-react"
import "./style/payPeriodTable.css"

//Gets the holiday associated with the date
function getHolidays(holidays, date) {

    let filteredHolidays = holidays.filter(holiday => {

        const holidayBegin = holiday.holidayBeginObject;
        
        if(holiday.holidayEnd == null) {
            return holidayBegin.isSame(date, "day")
        }

        else {
            const holidayEnd = holiday.holidayEndObject;

            return (
                date.isSameOrAfter(holidayBegin, "day")
                && date.isSameOrBefore(holidayEnd, "day")
            )
        }
    })

    return filteredHolidays;
}


let PayPeriodTable = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);

    if (props.mode == "mutate") {
        return (
            <tbody>
                {props.days.map((day) => {
                    let holidays = getHolidays(props.holidays, day.date.clone());
                        
                    return (
                        <TimeStampField 
                            holidays={holidays}
                            key={day.dayName} 
                            day={day}
                            disabled={
                                day.date.clone() > moment(props.startDate) ||
                                day.date.clone() < moment(props.endDate)
                            }
                        />
                    )}
                 )}
            </tbody>
        );
    }
    else {
        return (
            <tbody>
                {props.days.map((day) => {
                    let holidays = getHolidays(props.holidays, day.date.clone());
                    console.log(day.inObject)
                    return (
                        <React.Fragment>
                        <tr className={holidays.length > 0 ? "isHoliday" : ""} >
                            <th className="text-center align-middle" scope="row">
                                <p style={{ marginBottom: "0" }}>{day.dayName}</p>
                                <span className="sub">{day.date.format("l")}</span>
                            </th>
                            <td className="text-center">{day.inObject ? day.hourDisplay(day.in) : "N/A"}</td>
                            <td className="text-center">{day.outObject ? day.hourDisplay(day.out) : "N/A"}</td>
                            <td className="text-center">{day.lunchInObject ? day.hourDisplay(day.lunchIn) : "N/A"}</td>
                            <td className="text-center">{day.lunchOutObject ? day.hourDisplay(day.lunchOut) : "N/A"}</td>
                            <td className="text-center">{day.totalTime}</td>
                        </tr>
                        {holidays.length > 0 && (
                            <tr className="holidayInfoRow">
                                <td colSpan="6"><b>Note: </b>
                                    {holidays[0].note ? holidays[0].note : ` ${holidays[0].holidayName} takes place on this day. Please ensure any hours you worked are logged accurately.`}
                                </td>
                            </tr>
                        )}
                        </React.Fragment>
                    )
                })}
            </tbody>
        );
    }
}


export default PayPeriodTable